@if (appLoaded()) {
  <slotcom-header [gameView]="false"></slotcom-header>
  <main
    id="app-main"
    class="slotcom-main-content">
    <router-outlet></router-outlet>
  </main>
} @else {
  <slotcom-pre-loader></slotcom-pre-loader>
}
